import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  PictureAsPdf as PdfIcon,
  Description as DocIcon,
  TableChart as CsvIcon,
  InsertPhoto as ImageIcon,
  InsertDriveFile as DefaultIcon,
    Folder as FolderIcon
} from '@mui/icons-material';
import { red, blue, green, orange, grey, blueGrey } from '@mui/material/colors';

const FileIcon = ({ filename, path, isFolder=false }) => {


  const getFileExtension = (file) => {
    const fileName = file.split('/').pop();
    return fileName.substring(fileName.lastIndexOf('.') + 1);
  };

  const renderIcon = (extension) => {

    if (isFolder) return <FolderIcon sx={{ color: grey[800] }} />;

    switch (extension.toLowerCase()) {
      case 'pdf':
        return <PdfIcon sx={{ color: red[700] }} />;
      case 'doc':
      case 'docx':
        return <DocIcon sx={{ color: blue[500] }} />;
      case 'csv':
        return <CsvIcon sx={{ color: green[500] }} />;
      case 'png':
      case 'jpg':
      case 'jpeg':
        return <ImageIcon sx={{ color: orange[700] }} />;
      default:
        return <DefaultIcon sx={{ color: blueGrey[300] }} />;
    }
  };

  const filePath = path || filename;
  const extension = getFileExtension(filePath);

  return (
    <Tooltip title={filePath}>
      <IconButton>
        {renderIcon(extension)}
      </IconButton>
    </Tooltip>
  );
};

export default FileIcon;